import React from "react";
import { Tag, Tooltip } from 'antd';
import { getIcon } from "../../../../utils/images";
import Track from "../../../Track/Track";
import { getStateColorMap } from "../../../../utils/utils";


export const Logo = ({ star, shipment, clickRow }) => {
  return (
    <Tooltip title={shipment.shipping_line?.name}>
      <div className="logo" data-starred={star} onClick={() => clickRow(shipment)}>
        <img src={shipment.shipping_line?.icon || getIcon('logo-mini')} />
      </div>
    </Tooltip>
  )
}

export const ReferenceNumber = ({ booking_number, shipment, clickRow }) => {
  return (
    shipment.group?.length > 1
      ? (
        <div className="number">
          {shipment.group.length} Shipments
        </div>
      )
      : (
        <div className="ref-num" onClick={() => clickRow(shipment)}>
          <div className="number">
            {booking_number}
          </div>
          {shipment.bl && (
            <div className="sub-number">
              {shipment.bl}
            </div>
          )}
          {shipment.client_ref && (
            <div className="sub-number">
              {shipment.client_ref}
            </div>
          )}
        </div>
      )
  )
}

export const RouteTrack = ({ shipment, clickRow }) => {
  return <div className="track-wrapper" onClick={() => clickRow(shipment)}> {shipment.pol?.name && <Track shipment={shipment} />}</div>
}

export const Status = ({ state, shipment, clickRow }) => {
  return (
    <div className="status" onClick={() => clickRow(shipment)}>
      <Tag className="tag" color={getStateColorMap(state)?.color}>{getStateColorMap(state)?.display}</Tag>
    </div>
  )
}

export const Cargo = ({ cargo, shipment, clickRow }) => {
  if (shipment.group) {
    let cargoAccumalator = shipment.group
      .map(s => s.cargo)
      .filter(cargo => !!cargo)
      .reduce((acc, cargo) => {
        let [container, count] = cargo.split("x")
        container = container.trim()
        count = Number.parseInt(count)

        acc[container] = (acc[container] || 0) + count
        return acc
      }, {})

    let cargoList = []
    for (let [container, count] of Object.entries(cargoAccumalator)) {
      cargoList.push(`${container} x ${count}`)
    }

    cargo = cargoList.join(', ')
  }


  return (
    <div onClick={() => clickRow(shipment)}>{cargo}</div>
  )
}

export const Tags = ({ tags, shipment, clickRow, tagSummary }) => {
  return (
    tags ?
    (
      tags.length
        ?
        <>
          <div className="tags" onClick={() => clickRow(shipment)}>{tagSummary(tags, true)}</div>
          <div className="tags-short" onClick={() => clickRow(shipment)}>{tagSummary(tags)}</div>
        </>
        : <></>
    ) : <></>
  )
}
